import { createBrowserClient } from '@supabase/ssr';

/**
 * Shared Supabase client for both Next.js (backend) and React (frontend).
 * CRA requires REACT_APP_ prefix, while Next.js uses NEXT_PUBLIC_.
 */
export function createBrowserSupabaseClient() {
  const url = process.env.REACT_APP_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !key) {
    console.error(
      'Supabase configuration is missing. Ensure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY (for CRA) ' +
      'or NEXT_PUBLIC_ prefixes (for Next.js) are set in your environment.'
    );
    // Returning null to allow calling components to provide a graceful fallback UI
    return null;
  }

  return createBrowserClient(url, key);
}
